// Payments Page
export const PAYMENTS_PAGE__TITLE = 'Payments';
export const PAYMENTS_PAGE__ADD_PAYMENT_BUTTON = 'Add Payment';
export const PAYMENTS_PAGE__APPLY_PAYMENT_BUTTON = 'Apply Payment';
export const PAYMENTS_PAGE__TABLE_HEADER__PAYMENT_ID = 'Payment ID';
export const PAYMENTS_PAGE__TABLE_HEADER__AMOUNT = 'Amount';
export const PAYMENTS_PAGE__TABLE_HEADER__STATUS = 'Status';
export const PAYMENTS_PAGE__TABLE_HEADER__CREATED_DATE = 'Date Created';
export const PAYMENTS_PAGE__TABLE_ACTION__EDIT = 'Edit';

// Payment Page
export const PAYMENT_PAGE__TITLE = 'Payment';
export const PAYMENT_PAGE__APPLY_PAYMENT_BUTTON = 'Apply Payment';
export const PAYMENT_PAGE__EDIT_BUTTON = 'Edit Payment';
export const PAYMENT_PAGE__BACK_BUTTON = 'Back';
export const PAYMENT_PAGE__PAYMENT_NOT_FOUND = 'Payment not found';
export const PAYMENT_PAGE__PAYMENT_NOT_FOUND_ACTION_TEXT = 'Go Back';
export const PAYMENT_PAGE__PAYMENT_AMOUNT_TITLE = 'Amount';
export const PAYMENT_PAGE__PAYMENT_STATUS_TITLE = 'Status';
export const PAYMENT_PAGE__PAYMENT_CREATED_DATE_TITLE = 'Date Created';
export const PAYMENT_PAGE__PAYMENT_MODIFIED_DATE_TITLE = 'Last Modified';
export const PAYMENT_PAGE__HISTORY_TITLE = 'Payment History';
export const PAYMENT_PAGE__POLICY_TITLE = 'Policy';
export const PAYMENT_PAGE__POLICYHOLDER_TITLE = 'Policyholder';

// Payment Schema
export const PAYMENT_SCHEMA__READY_TO_POST_ERROR =
	'Policy is required to be ready';

// Create Payment Page
export const CREATE_PAYMENT_PAGE__TITLE = 'New Payment';
export const CREATE_PAYMENT_PAGE__SUBMIT = 'Create';
export const CREATE_PAYMENT_PAGE__CANCEL = 'Cancel';
export const CREATE_PAYMENT_PAGE__READY_TO_POST_LABEL = 'Ready';

// Edit Payment Page
export const EDIT_PAYMENT_PAGE__PAYMENT_NOT_FOUND =
	'Unable to find payment with locator ';
export const EDIT_PAYMENT_PAGE__PAYMENT_NOT_FOUND_ACTION_TEXT = 'Go Back';
export const EDIT_PAYMENT_PAGE__TITLE = 'Edit Payment';
export const EDIT_PAYMENT_PAGE__SUBMIT = 'Save';
export const EDIT_PAYMENT_PAGE__CANCEL = 'Cancel';
export const EDIT_PAYMENT_PAGE__READY_TO_POST_LABEL = 'Ready';

// Discard Payment Modal
export const DISCARD_PAYMENT_MODAL__BUTTON = 'Discard Payment';
export const DISCARD_PAYMENT_MODAL__TITLE = 'Discard Payment';
export const DISCARD_PAYMENT_MODAL__BODY_TEXT_TITLE =
	'Are you sure you want to discard this payment? This action cannot be undone.';
export const DISCARD_PAYMENT_MODAL__SUBMIT = 'Discard';
export const DISCARD_PAYMENT_MODAL__CANCEL = 'Cancel';

// Decline Payment Modal
export const DECLINE_PAYMENT_MODAL__BUTTON = 'Decline Payment';
export const DECLINE_PAYMENT_MODAL__TITLE = 'Decline Payment';
export const DECLINE_PAYMENT_MODAL__BODY_TEXT_TITLE =
	'Are you sure you want to mark this payment as declined?';
export const DECLINE_PAYMENT_MODAL__SUBMIT = 'Mark as Declined';
export const DECLINE_PAYMENT_MODAL__CANCEL = 'Cancel';

// Return Payment Modal
export const RETURN_PAYMENT_MODAL__BUTTON = 'Return Payment';
export const RETURN_PAYMENT_MODAL__TITLE = 'Return Payment';
export const RETURN_PAYMENT_MODAL__BODY_TEXT_TITLE =
	'Are you sure you want to mark this payment as returned?';
export const RETURN_PAYMENT_MODAL__SUBMIT = 'Mark as Returned';
export const RETURN_PAYMENT_MODAL__CANCEL = 'Cancel';

// Ready To Post Payment Modal
export const READY_TO_POST_MODAL__BUTTON = 'Ready Payment';
export const READY_TO_POST_MODAL__TITLE = 'Mark as Ready';
export const READY_TO_POST_MODAL__BODY_TEXT_TITLE =
	'Are you sure you want to mark this payment as Ready?';
export const READY_TO_POST_MODAL__SUBMIT = 'Mark as Ready';
export const READY_TO_POST_MODAL__CANCEL = 'Cancel';

// Return To Draft Payment Modal
export const RETURN_TO_DRAFT_PAYMENT_MODAL__BUTTON = 'Edit Payment';
export const RETURN_TO_DRAFT_PAYMENT_MODAL__TITLE = 'Edit Payment';
export const RETURN_TO_DRAFT_PAYMENT_MODAL__BODY_TEXT_TITLE =
	'To edit the payment, it must be returned to draft. Are you sure you want to return this payment to draft?';
export const RETURN_TO_DRAFT_PAYMENT_MODAL__SUBMIT = 'Edit Payment';
export const RETURN_TO_DRAFT_PAYMENT_MODAL__CANCEL = 'Cancel';

// Write Off Modal
export const WRITE_OFF_INVOICE_MODAL__BUTTON = (isCatchUp?: boolean) =>
	`Write Off ${isCatchUp ? 'Catch-Up' : 'Invoice'}`;
export const WRITE_OFF_INVOICE_MODAL__TITLE = (isCatchUp?: boolean) =>
	`Write Off ${isCatchUp ? 'Catch-Up' : 'Invoice'}`;
export const WRITE_OFF_INVOICE_MODAL__BODY_TEXT_TITLE = (
	invoiceId: string,
	isCatchUp?: boolean,
) => `This will write off ${isCatchUp ? 'Catch-Up' : 'Invoice'} ${invoiceId}.`;
export const WRITE_OFF_INVOICE__TITLE_ERROR = (isCatchUp?: boolean) =>
	`Error Writing Off ${isCatchUp ? 'Catch-Up' : 'Invoice'}`;
export const WRITE_OFF_INVOICE_MODAL__BODY_TEXT_TITLE_ERROR = (
	invoiceId: string,
	isCatchUp?: boolean,
) => `Failed to write off ${isCatchUp ? 'Catch-Up' : 'Invoice'} ${invoiceId}.`;
export const WRITE_OFF_INVOICE_MODAL__BODY_TEXT_TITLE_SUCCESS = (
	invoiceId: string,
	isCatchUp?: boolean,
) => `${isCatchUp ? 'Catch-Up' : 'Invoice'} ${invoiceId} has been written off.`;
export const WRITE_OFF_INVOICE__TRY_AGAIN = 'Try Again';
export const WRITE_OFF_INVOICE__TITLE_SUCCESS = (isCatchUp?: boolean) =>
	`${isCatchUp ? 'Catch-Up' : 'Invoice'} Written Off`;
export const WRITE_OFF_INVOICE_MODAL__LOADING = (isCatchUp?: boolean) =>
	`Writing Off ${isCatchUp ? 'Catch-Up' : 'Invoice'}...`;
export const WRITE_OFF_INVOICE_MODAL__SUBMIT = (isCatchUp?: boolean) =>
	`Write Off ${isCatchUp ? 'Catch-Up' : 'Invoice'}`;
export const WRITE_OFF_INVOICE_MODAL__CANCEL = 'Cancel';
export const WRITE_OFF_INVOICE_MODAL__DONE = 'Done';

// Reverse Payment Modal
export const REVERSE_PAYMENT_MODAL__BUTTON = 'Reverse Payment';
export const REVERSE_PAYMENT_MODAL__TITLE = 'Reverse Payment';
export const REVERSE_PAYMENT_MODAL__TITLE_ERROR = 'Error Reversing Payment';
export const REVERSE_PAYMENT_MODAL__TITLE_LOADING = 'Reversing Payment...';
export const REVERSE_PAYMENT_MODAL__TITLE_SUCCESS = 'Payment Reversed!';
export const REVERSE_PAYMENT_MODAL__BODY_TEXT_TITLE = (
	paymentId: string,
	invoiceId: string,
	isCatchUp: boolean,
) =>
	`This will unapply Payment ${paymentId} from ${
		isCatchUp ? 'Catch-Up' : 'Invoice'
	} ${invoiceId}.`;
export const REVERSE_PAYMENT_MODAL__BODY_TEXT_TITLE_SUCCESS = (
	paymentId: string,
	invoiceId: string,
) => `Payment ${paymentId} is no longer applied to Invoice ${invoiceId}.`;
export const REVERSE_PAYMENT_MODAL__BODY_TEXT_TITLE_ERROR = (
	paymentId: string,
	invoiceId: string,
) => `Failed to reverse Payment ${paymentId} from invoice ${invoiceId}.`;
export const REVERSE_PAYMENT_MODAL__NEW_CASH_BALANCE_TITLE = 'New Cash Balance';
export const REVERSE_PAYMENT_MODAL__SUBMIT = 'Reverse Payment';
export const REVERSE_PAYMENT_MODAL__TRY_AGAIN = 'Try Again';
export const REVERSE_PAYMENT_MODAL__DONE = 'Done';
export const REVERSE_PAYMENT_MODAL__CANCEL = 'Cancel';
export const REVERSE_PAYMENT_MODAL__REASON_NAME = 'Reason For Reversal';
export const REVERSE_PAYMENT_MODAL__COMMENT = 'Comments';

// Payment State Chip
export const PAYMENT_STATE_CHIP__DRAFT = 'Draft';
export const PAYMENT_STATE_CHIP__POSTED = 'Posted';
export const PAYMENT_STATE_CHIP__READY = 'Ready';
export const PAYMENT_STATE_CHIP__DECLINED = 'Declined';
export const PAYMENT_STATE_CHIP__RETURNED = 'Returned';
export const PAYMENT_STATE_CHIP__DISCARDED = 'Discarded';
export const PAYMENT_STATE_CHIP__ERROR = 'Status Not Found';

// Payment API
export const PAYMENT_API_MUTATION__UPDATE_STATUS_ERROR_TOAST =
	'Error updating payment status: ';
export const PAYMENT_API_MUTATION__STATUS_UPDATE_SUCCESS_TOAST =
	'Payment status updated successfully';
export const PAYMENT_API_MUTATION__UPDATE_SUCCESS_TOAST =
	'Payment saved successfully';
export const PAYMENT_API_MUTATION__UPDATE_ERROR_TOAST =
	'Error saving payment: ';
export const PAYMENT_API_MUTATION__CREATE_SUCCESS_TOAST =
	'Payment created successfully';
export const PAYMENT_API_MUTATION__CREATE_ERROR_TOAST =
	'Error creating payment: ';

// Apply Payment Modal
export const APPLY_PAYMENT_MODAL__TITLE = 'Apply Payment';
export const APPLY_PAYMENT_MODAL__PAYMENT_ID = 'Payment ID';
export const APPLY_PAYMENT_MODAL__PAYMENT_AMOUNT = 'Payment Amount';
export const APPLY_PAYMENT_MODAL__POLICYHOLDER = 'Policyholder';
export const APPLY_PAYMENT_MODAL__POLICY = 'Policy';
export const APPLY_PAYMENT_MODAL__INVOICE = 'Invoice';
export const APPLY_PAYMENT_MODAL__CATCHUP = 'Catch-Up';
export const APPLY_PAYMENT_MODAL__TOTAL_DUE = 'Total Due';
export const APPLY_PAYMENT_MODAL__CANCEL_BUTTON = 'Cancel';
export const APPLY_PAYMENT_MODAL__PAY_NOW_BUTTON = 'Apply Payment';
export const APPLY_PAYMENT_MODAL__SELECT_INVOICE = 'Select an invoice';
export const APPLY_PAYMENT_MODAL__SELECT_INVOICE_TYPE = 'Select type';
export const APPLY_PAYMENT_MODAL__NO_INVOICE = 'No invoices';
export const APPLY_PAYMENT_MODAL__POLICY_NO_INVOICE =
	'This policy does not have any invoices issued';
export const APPLY_PAYMENT_MODAL__NO_INVOICE_ERROR =
	'Select an invoice to continue';
export const APPLY_PAYMENT_MODAL__NO_CATCHUP = 'No catch-ups';
export const APPLY_PAYMENT_MODAL__POLICY_NO_CATCHUP =
	'This policy does not have any catch-ups issued';
export const APPLY_PAYMENT_MODAL__NO_CATCHUP_ERROR =
	'Select a catch-up to continue';
export const APPLY_PAYMENT_MODAL__DONE_BUTTON = 'Done';

// Invoice Paid Modal Content
export const INVOICE_PAID_MODAL_CONTENT__FAILURE_TITLE = 'Something went wrong';
export const INVOICE_PAID_MODAL_CONTENT__CLOSE_BUTTON = 'Close';
export const INVOICE_PAID_MODAL_CONTENT__TRY_AGAIN_BUTTON = 'Try Again';
export const INVOICE_PAID_MODAL_CONTENT__SUCCESS_TITLE = 'Invoice Paid';
export const INVOICE_PAID_MODAL_CONTENT__SUCCESSFUL_CASH_BALANCE_USAGE = (
	invoiceId: string,
) => `Invoice ${invoiceId} has been paid with the policy cash balance.`;
export const INVOICE_PAID_MODAL_CONTENT__SUCCESS_CONTENT = (
	paymentId: string,
	invoiceId: string,
) => `Payment ${paymentId} has been applied to Invoice ${invoiceId}`;
export const INVOICE_PAID_MODAL_CONTENT__FAILURE_CONTENT =
	"We weren't able to apply the payment to the invoice at this time. Please try again.";
export const INVOICE_PAID_MODAL_CONTENT__DONE_BUTTON = 'Done';
export const INVOICE_PAID_MODAL_CONTENT__NEW_CASH_BALANCE = 'New Cash Balance';

// Pay Invoice Modal
export const PAY_INVOICE_MODAL__TITLE = (isCatchup: boolean) =>
	isCatchup ? 'Pay Catch-Up' : 'Pay Invoice';
export const PAY_INVOICE_MODAL__APPLY_PAYMENT_TITLE = 'Apply New Payment';
export const PAY_INVOICE_MODAL__INVOICE_LABEL = (isCatchup: boolean) =>
	isCatchup ? 'Catch-Up' : 'Invoice';
export const PAY_INVOICE_MODAL__POLICY_LABEL = 'Policy';
export const PAY_INVOICE_MODAL__PAYMENT_DUE_DATE_LABEL = 'Payment Due Date';
export const PAY_INVOICE_MODAL__TOTAL_DUE_LABEL = 'Total Due';
export const PAY_INVOICE_MODAL__SELECT_PAYMENT = 'Select Payment';
export const PAY_INVOICE_MODAL__APPLY_NEW_PAYMENT = 'or apply new payment';
export const PAY_INVOICE_MODAL__PAYMENT_DISPLAY = (paymentId: string) =>
	`Payment ${paymentId}`;
export const PAY_INVOICE_MODAL__PAYMENT_STATE = 'Ready';
export const PAY_INVOICE_MODAL__USE_CASH_BALANCE = 'Use Cash Balance';
export const PAY_INVOICE_MODAL__RETAIN_IN_CASH_BALANCE =
	'Retain in Cash Balance';
export const PAY_INVOICE_MODAL__NO_PAYMENTS_FOUND = 'No Payments Found';
export const PAY_INVOICE_MODAL__NO_ELIGIBLE_PAYMENTS =
	'No eligible payments found.';
export const PAY_INVOICE_MODAL__CANCEL_BUTTON = 'Cancel';
export const PAY_INVOICE_MODAL__PAY_NOW_BUTTON = 'Pay Now';
export const PAY_INVOICE_MODAL__DONE_BUTTON = 'Done';

// Payments breadcrumbs
export const PAYMENTS_BREADCRUMBS__PAYMENTS = 'Payments';
export const PAYMENTS_BREADCRUMBS__EDIT = 'Edit';
export const PAYMENTS_BREADCRUMBS__NEW = 'New';
export const PAYMENTS_BREADCRUMBS__PAYMENT_DISPLAY_ID = (paymentId: string) =>
	`Payment ${paymentId}`;
